import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import {
  Box,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { fr } from 'date-fns/locale';
import React, { forwardRef } from 'react';
import ReactDatePicker from 'react-datepicker';

const PICK_UP_TIME = [
  'entre 09:00 et 12:00',
  'entre 12:00 et 14:00',
  'entre 14:00 et 17:00',
  'entre 17:00 et 20:00',
];

const DateSelectInput = forwardRef(({ value, onClick, error }, ref) => (
  <TextField
    variant="outlined"
    onClick={onClick}
    value={value}
    ref={ref}
    size="small"
    error={error}
    fullWidth
    slotProps={{
      input: {
        startAdornment: (
          <InputAdornment position="start">
            <CalendarTodayIcon />
          </InputAdornment>
        ),
      },
    }}
  />
));

const PickUpDateTime = ({ formData, handleFormChange, formError }) => {
  const years = Array.from(
    { length: 10 },
    (_, i) => new Date().getFullYear() + i
  );
  const months = [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ];

  return (
    <Box sx={{ width: '100%', mt: 3 }}>
      <Typography
        color="primary"
        sx={{ fontSize: '1em', fontWeight: 'bold', mb: 1 }}
      >
        Date et heure de l&apos;enlèvement
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 0 }}>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Box sx={{ width: '50%' }}>
            <ReactDatePicker
              popperPlacement="top"
              selected={formData.pickUpDate}
              onChange={(date) => {
                handleFormChange({ key: 'pickUpDate', value: date });
              }}
              dateFormat="dd/MM/yyyy"
              locale={fr}
              excludeDateIntervals={[
                {
                  start: new Date(0),
                  end: new Date(),
                },
              ]}
              customInput={
                <DateSelectInput error={Boolean(formError.pickUpDate)} />
              }
              renderCustomHeader={({ date, changeYear, changeMonth }) => (
                <div
                  style={{
                    margin: 10,
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 10,
                  }}
                >
                  <select
                    value={date.getFullYear()}
                    onChange={({ target: { value } }) =>
                      changeYear(Number(value))
                    }
                  >
                    {years.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>

                  <select
                    value={months[date.getMonth()]}
                    onChange={({ target: { value } }) =>
                      changeMonth(months.indexOf(value))
                    }
                  >
                    {months.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            />
            {formError.pickUpDate && (
              <FormHelperText error>{formError.pickUpDate}</FormHelperText>
            )}
          </Box>
          <FormControl
            fullWidth
            size="small"
            error={Boolean(formError.pickUpTime)}
          >
            <InputLabel>Heure</InputLabel>
            <Select
              label="Heure"
              value={formData.pickUpTime}
              onChange={(e) =>
                handleFormChange({ key: 'pickUpTime', value: e.target.value })
              }
              sx={{ width: '50%' }}
              size="small"
            >
              {PICK_UP_TIME.map((time) => (
                <MenuItem key={time} value={time}>
                  {time}
                </MenuItem>
              ))}
            </Select>
            {formError.pickUpTime && (
              <FormHelperText>{formError.pickUpTime}</FormHelperText>
            )}
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
};

export default PickUpDateTime;
